function log(...args) {
	if (window.console && window.console.log) {
		window.console.log('[ZDFCMP]', ...args);
	}
}

class Wrapper {
	constructor() {
		this._consentCategoryMapping = {
			required: 'C0001',
			tracking: 'C0002',
			personalization: 'C0003',
			social: 'C0005', // Don't use directly, only access subcategories.
			twitter: 'S5001',
			instagram: 'S5002',
			facebook: 'S5003',
			thirdparty: 'S5004',
		};
		this._api = null;
		this._callbacks = [];
		this._onReady = this._onReady.bind(this);
		this._onChange = this._onChange.bind(this);

		this._initialize();
	}

	_initialize() {
		log('Initializing ZDF CMP Wrapper.');

		if (window.Optanon) {
			this._onReady();
			return;
		}

		log('Optanon is not ready, we have to wait for the OptanonWrapper call.');

		// We are about to hijack the OptanonWrapper callback. Remember the old one.
		if (window.OptanonWrapper !== this._onReady) {
			this._globalCallback = window.OptanonWrapper;
		}

		// After storing the original callback, we hijack the function.
		window.OptanonWrapper = this._onReady;
	}

	addChangeCallback(callback) {
		// Check if callback is already registered.
		if (this._callbacks.indexOf(callback) >= 0) {
			return false;
		}

		this._callbacks.push(callback);
		return true;
	}

	hasCategoryConsent(category) {
		var catId = this._consentCategoryMapping[category];

		if (!this._api || typeof window.OptanonActiveGroups !== 'string') {
			log('Optanon not yet ready, will not return consent state now.');
			return null;
		}

		if (Object.keys(this._consentCategoryMapping).indexOf(category) < 0) {
			log(`Unknown consent category ${category}, ignoring request.`);
			return false;
		}

		log(`Consent for ${category} requested.`);
		return window.OptanonActiveGroups.includes(catId);
	}

	getCategoryPurposeId(category) {
		var
			purposeId = null,
			groupId = this._consentCategoryMapping[category]
		;

		if (!this._api || typeof window.OptanonActiveGroups !== 'string') {
			log('Optanon not yet ready, will not accept consent changes now.');
			return null;
		}

		this._api.GetDomainData().Groups.forEach((group) => {
			if (group.CustomGroupId === groupId) {
				purposeId = group.PurposeId;
			}
		});

		return purposeId;
	}

	setCategoryConsent(category, state) {
		state = typeof state === 'boolean' ? state : true;

		if (!this._api || typeof window.OptanonActiveGroups !== 'string') {
			log('Optanon not yet ready, will not accept consent changes now.');
			return false;
		}

		if (category !== 'all' && Object.keys(this._consentCategoryMapping).indexOf(category) < 0) {
			log(`Unknown consent category ${category}, ignoring change.`);
			return false;
		}

		log(`Consent for ${category} should be changed to ${state}`);

		// Special handling for category "all"
		if (category === 'all') {
			if (state) {
				this._api.AllowAll();
			} else {
				this._api.RejectAll();
			}
		} else {
			var
				purposeId = this.getCategoryPurposeId(category),
				saveButton = document.querySelector('#onetrust-consent-sdk .save-preference-btn-handler')
			;

			log(`Using purpose ID ${purposeId} for ${category}`);
			this._api.setConsentProfile({
				purposes: [
					{Id: purposeId, TransactionType: state ? 'CONFIRMED' : 'OPT_OUT'}
				]
			});

			// For some weird reason, no change callback and OptanonActiveGroups is not updated.
			// We need to trigger a click on the "save" button.
			saveButton.click();
		}
		return true;
	}

	openSettings() {
		this._api.ToggleInfoDisplay();
	}

	_onReady() {
		if (!window.Optanon) {
			log('Optanon not ready, trigger initialization again.');
			this._initialize();
			return;
		}

		log('Optanon loaded, restoring and calling global callback.');
		window.OptanonWrapper = this._globalCallback;
		if (typeof this._globalCallback === 'function') {
			log('Calling original OptanonWrapper function.');
			this._globalCallback();
		}

		this._api = window.Optanon;
		this._api.OnConsentChanged(this._onChange);
		log('Optanon is ready.');
		this._onChange();
	}

	_onChange() {
		log('Optanon consent changed.');
		this._callbacks.forEach((callback) => {
			callback(); // eslint-disable-line callback-return
		});
	}


}


var
	wrapper = () => {
		return new Wrapper();
	}
;


wrapper = wrapper();
var wrapper$1 = wrapper;

function addConsentChangedCallback(callback) {
	return wrapper$1.addChangeCallback(callback);
}


function openCMPSettings() {
	return wrapper$1.openSettings();
}


function hasTrackingConsent() {
	return wrapper$1.hasCategoryConsent('tracking');
}


function hasPersonalizationConsent() {
	return wrapper$1.hasCategoryConsent('personalization');
}


function hasTwitterConsent() {
	return wrapper$1.hasCategoryConsent('twitter');
}


function hasInstagramConsent() {
	return wrapper$1.hasCategoryConsent('instagram');
}


function hasFacebookConsent() {
	return wrapper$1.hasCategoryConsent('facebook');
}


function hasThirdPartyConsent() {
	return wrapper$1.hasCategoryConsent('thirdparty');
}


function setTrackingConsent(state) {
	return wrapper$1.setCategoryConsent('tracking', state);
}


function setPersonalizationConsent(state) {
	return wrapper$1.setCategoryConsent('personalization', state);
}


function setTwitterConsent(state) {
	return wrapper$1.setCategoryConsent('twitter', state);
}


function setInstagramConsent(state) {
	return wrapper$1.setCategoryConsent('instagram', state);
}


function setFacebookConsent(state) {
	return wrapper$1.setCategoryConsent('facebook', state);
}


function setThirdPartyConsent(state) {
	return wrapper$1.setCategoryConsent('thirdparty', state);
}


function setAllConsent(state) {
	return wrapper$1.setCategoryConsent('all', state);
}

export { addConsentChangedCallback, hasFacebookConsent, hasInstagramConsent, hasPersonalizationConsent, hasThirdPartyConsent, hasTrackingConsent, hasTwitterConsent, openCMPSettings, setAllConsent, setFacebookConsent, setInstagramConsent, setPersonalizationConsent, setThirdPartyConsent, setTrackingConsent, setTwitterConsent, wrapper$1 as wrapper };
//# sourceMappingURL=index.js.map
